import { cn } from "@kyan/ui";

import type { OptionChainColumnGroup } from "../OptionChain.types";

interface OptionChainGroupEffectProps {
  group: OptionChainColumnGroup;
  isActive?: boolean;
}

export const OptionChainGroupEffect: React.FC<OptionChainGroupEffectProps> = ({
  group,
  isActive = false,
}) => {
  const isAsk = (["C:ask", "P:ask"] as OptionChainColumnGroup[]).includes(
    group,
  );
  const isBid = (["C:bid", "P:bid"] as OptionChainColumnGroup[]).includes(
    group,
  );

  const bgGradientClasses = cn("to-transparent", {
    "from-error/30 bg-gradient-to-r": isAsk,
    "from-success/30 bg-gradient-to-l": isBid,
  });

  return (
    <div
      className={cn(
        "absolute inset-0 opacity-0 transition-opacity group-hover:opacity-100 before:absolute before:inset-0 before:to-transparent before:opacity-0 before:transition-opacity",
        {
          "opacity-100 before:opacity-100": isActive,
        },
        bgGradientClasses,
        {
          "before:from-error before:bg-gradient-to-r": isAsk,
          "before:from-success before:bg-gradient-to-l": isBid,
        },
      )}
    >
      <div className="dark:bg-background absolute inset-px bg-white">
        <div className={cn("size-full", bgGradientClasses)} />
      </div>
    </div>
  );
};
